import React from "react";
import "./Label.css";

const Label = ({ text = "... text" }) => {
    return (
        <div className="col-md-12 mb-2 label_container">
            <span className="material-symbols-outlined label_icon">label</span>
            <small className="label_title">{text}</small>
        </div>
    );
};

export default Label;
